<script setup lang="ts">
import { VdDropdown, VdDropdownItem } from "@voodoo.io/voodoo-ui";
import { PropType, computed } from "vue";

import { Layer } from "@/graphql";

const props = defineProps({
  layers: {
    type: Array as PropType<Layer[]>,
    required: true,
    default: () => [],
  },
  selectedLayer: {
    type: String,
    default: "default",
  },
});

const lockedClasses = computed(() => props.layers.find((l) => l.id === props.selectedLayer)?.lockedClasses || []);

const message = computed(() => {
  const nb = lockedClasses.value.length;
  return nb > 1 ? `${nb} locked classes` : `${nb} locked class`;
});
</script>

<template>
  <VdDropdown
    v-if="lockedClasses && lockedClasses.length > 0"
    type="tertiary"
    skin="danger"
    :label="message"
    icon-left="fa:lock"
    :suffix-icon="null"
  >
    <VdDropdownItem v-for="item in lockedClasses" :key="item">{{ item }}</VdDropdownItem>
  </VdDropdown>
</template>
